import React from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import presidentimg from "../assets/Img/airaa-president-dev-mohanty.webp";

const PresidentMessage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center px-4 py-8">
      <div className="bg-white shadow-2xl rounded-3xl p-6 md:p-10 max-w-6xl w-full flex flex-col md:flex-row items-center transform transition duration-500 hover:scale-105 border-l-8 border-green-600">
        <img
          src={presidentimg}
          alt="President"
          className="w-32 h-32 md:w-48 md:h-48 rounded-full object-cover border-4 border-green-600 shadow-xl mb-4 md:mb-0 md:mr-8 transition-all duration-300 hover:shadow-lg hover:shadow-green-400"
        />
        <div className="text-center md:text-left relative w-full">
          <h2 className="text-2xl md:text-4xl font-extrabold text-blue-900 leading-tight mb-6 md:mb-12 border-b-4 border-green-600 inline-block pb-1">
            {t("presidentMessageTitle")}
          </h2>
          {/* <FaQuoteLeft className="text-blue-500 text-3xl absolute bottom-15 left-0" /> */}
          <p className="text-gray-700 text-base md:text-lg leading-relaxed italic px-2 md:px-4 text-justify">
            <span className="font-semibold text-blue-600">AIRAA</span> {t("presidentMessage")}
          </p>
          {/* <FaQuoteRight className="text-blue-500 text-3xl absolute -bottom-6 right-0" /> */}
        </div>
      </div>
    </div>

  );
};

export default PresidentMessage;
